// src/store/api/departmentApiSlice.js
import { apiSlice } from "./apiSlice";

export const departmentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getDepartments: builder.query({
			query: () => "/Department",
			providesTags: ["Departments"],
		}),

		getDepartmentById: builder.query({
			query: (id) => `/Department/${id}`,
			providesTags: (result, error, id) => [{ type: "Departments", id }],
		}),

		createDepartment: builder.mutation({
			query: (departmentData) => ({
				url: "/Department",
				method: "POST",
				body: departmentData,
			}),
			invalidatesTags: ["Departments"],
		}),

		updateDepartment: builder.mutation({
			query: ({ id, ...departmentData }) => ({
				url: `/Department/${id}`,
				method: "PUT",
				body: { id, ...departmentData },
			}),
			invalidatesTags: (result, error, { id }) => [
				"Departments",
				{ type: "Departments", id },
			],
		}),

		deleteDepartment: builder.mutation({
			query: (id) => ({
				url: `/Department/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: ["Departments"],
		}),
	}),
});

export const {
	useGetDepartmentsQuery,
	useGetDepartmentByIdQuery,
	useCreateDepartmentMutation,
	useUpdateDepartmentMutation,
	useDeleteDepartmentMutation,
} = departmentApiSlice;
